/**
 * Phase 6e.2 — build an O(1) lookup index from the backend response.
 *
 * The backend response is a sparse list of rows (one per business
 * day with data). Missing dates from `response.data.missingDates`
 * are intentionally NOT added to the index — their absence is the
 * signal that triggers T-1 fallback in `lookupRate`.
 *
 * Null currency values (e.g. backend ships `{ USD: null }` for a
 * currency that had no `<Currency Kod="USD">` block on a given day)
 * ARE preserved as-is — the matcher treats `null` the same as
 * "missing entry" and walks back, which is the correct audit
 * convention.
 */

import type { FxRatesApiResponse, RatesByDate } from './types';

export function buildRatesIndex(response: FxRatesApiResponse): RatesByDate {
  const idx: RatesByDate = {};
  for (const row of response.data.rows) {
    idx[row.date] = row.rates;
  }
  return idx;
}
